module.exports = "https://web-assets-production.autolist.com/_next/static/images/oem-logos-sprite-50612ca56edd03d124e8e164ca6b2de0.png";